<template lang="pug">
  shListData(title="Locations History" resolver="locationsHistory" keyData="_id" component="shLocation" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'LocationsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/location/LocationsHistory.vue